export { default } from './parseAssessmentSettings';
